import type {ReactNode} from 'react'
import {Badge} from '@/components/ui/badge'
import {Button} from '@/components/ui/button'
import {X} from 'lucide-react'

interface DismissibleBadgeProps {
    children: ReactNode
    onDismiss: () => void
    'data-testid'?: string
}

export function DismissibleBadge({children, onDismiss, 'data-testid': testId}: DismissibleBadgeProps) {
    return (
        <Badge variant="secondary" className="flex items-center gap-1">
            {children}
            <Button
                variant="ghost"
                size="sm"
                className="h-auto p-0 ml-1 hover:bg-transparent"
                onClick={onDismiss}
                data-testid={testId}
            >
                <X className="h-3 w-3"/>
            </Button>
        </Badge>
    )
}
